import React from 'react';
import { Eye, Sunrise, Feather } from 'lucide-react';
import { Reveal } from './Reveal';
import { Section } from './Section';
import styles from './BenefitsSection.module.css';

const benefits = [
  {
    title: 'You Know What You Eat',
    text: 'Grown by your hands. No pesticides, no supply chain, no mystery. Just clean food — from a seed you planted yourself.',
    Icon: Eye,
  },
  {
    title: 'A Moment That\'s Only Yours',
    text: 'Before the emails. Before the notifications. Five minutes with something alive — and quietly growing. That\'s the ritual.',
    Icon: Sunrise,
  },
  {
    title: 'Effortlessly Simple',
    text: 'No green thumb. No garden. No space. Everything fits on a windowsill. Everything fits in your life exactly as it is.',
    Icon: Feather,
  },
];

export function BenefitsSection() {
  return (
    <Section id="preco" title="Why It Works">
      <div className={styles.grid}>
        {benefits.map((benefit, index) => (
          <Reveal key={benefit.title} delayMs={index * 110}>
            <article className={styles.item}>
              <div className={styles.iconWrap} aria-hidden="true">
                <benefit.Icon className={styles.icon} strokeWidth={1.5} />
              </div>
              <h3 className={styles.itemTitle}>{benefit.title}</h3>
              <p className={styles.itemText}>{benefit.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
